import React, { memo } from 'react';
import {
  Button,
  Space,
  ModalContent,
  Loader,
  Text,
} from '@cashfree-intl/coherent';
import Lottie from 'react-lottie';

// Components
import CustomIcons from 'components/CustomIcons';

// Constants
import { hourGlassAnimationOptions, TEST_IDS } from '../constants';

// Styled
import { StyledReviewModal } from '../styled';

// Types
import { ICON_NAME } from 'components/CustomIcons/types';
import { ReviewModalProps } from '../types';

const ReviewModal = ({ onConfirm, isLoading, isWebsite }: ReviewModalProps) => {
  return (
    <StyledReviewModal open $maxWidth={502} data-testid={TEST_IDS.REVIEW_MODAL}>
      <Loader active={isLoading} page={false} />
      <ModalContent>
        <Space alignItems="center" direction="column">
          <Lottie
            options={hourGlassAnimationOptions}
            height={120}
            width={120}
          />
          <Text variant="h20" color="bodyLight" className="title">
            Your {isWebsite ? 'website pages are' : 'app package is'} under
            review
          </Text>
          <Text variant="b14" color="primary" className="chip">
            Usually takes less than 1 day
          </Text>
          <CustomIcons componentName={ICON_NAME.STAR} />
          <Button primary className="mt-3" onClick={onConfirm}>
            Ok, Got it
          </Button>
        </Space>
      </ModalContent>
    </StyledReviewModal>
  );
};

export default memo(ReviewModal);
